import { createRef } from 'react';

import { Divider } from '@material-ui/core/';

import PropTypes from 'prop-types';

import { scroller } from '@/src/lib/utils';

import Faq from './Faq';
import Features from './Features';
import Hero from './Hero';
import Partners from './Partners';
import Reviews from './Reviews';
import Solutions from './Solutions';

const sliceRender = ({ slice, refs, index }) => {
  const { slice_type: sliceType, items = [], primary = {} } = slice;

  switch (sliceType) {
    case 'divider':
      return <Divider key={index.toString()} />;
    case 'faq':
      return (
        <Faq
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          subtitle={primary.subtitle}
          cta={primary.cta}
          href={primary.href}
          questions={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'features':
      return (
        <Features
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          subtitle={primary.subtitle}
          features={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'hero':
      return (
        <Hero
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          subtitle={primary.subtitle}
          label={primary.label}
          image={primary.image}
          cta={primary.cta}
          href={primary.cta_href}
          customStyle={primary.style}
          refElem={refs[primary.ref_id]}
          onLearnMore={() =>
            setTimeout(
              () => scroller(refs[primary.learnmore_ref_id]?.current?.offsetTop - 200),
              500,
            )
          }
        />
      );
    case 'partners':
      return (
        <Partners
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          partners={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'reviews':
      return (
        <Reviews
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          subtitle={primary.subtitle}
          reviews={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'solutions':
      return (
        <Solutions
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          subtitle={primary.subtitle}
          solutions={items}
          refElem={refs[primary.ref_id]}
        />
      );
    default:
      return null;
  }
};

export default function SliceZone({ slices }) {
  const refs = slices.reduce((acc, slice) => {
    const { ref_id: refId } = slice?.primary;
    return refId ? { ...acc, [refId]: createRef() } : { ...acc };
  }, {});

  return <>{slices.map((slice, index) => sliceRender({ slice, refs, index }))}</>;
}

SliceZone.propTypes = {
  slices: PropTypes.array,
};
